// extracted by mini-css-extract-plugin
module.exports = {"chipRowContainer":"styles_chipRowContainer__2tz1O","chipRow":"styles_chipRow__3aKX_"};